// Library
import Image from "next/image";
import { Link } from "@/i18n/navigation";
import Ellipsis from "@/components/ui/Ellipsis/Ellipsis";
import { useTranslations } from "next-intl";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export default function CourseCard({ course, empty, skeleton, ...props }) {
    const t = useTranslations();

    if (empty) {
        return (
            <Card className="hover:bg-gray-50 dark:bg-bgDark-840 dark:hover:border-primary dark:hover:bg-bgDark-840/70 dark:border-borderDark transition-all duration-100 h-full flex flex-col overflow-hidden">
                <CardHeader className="pb-3 flex-1">
                    <div className="flex justify-between items-start">
                        <div className="rounded-[17.544%] overflow-hidden aspect-1 w-[64px] h-[64px]">
                            <Image
                                src="/images/site/courses/icon-progress.png"
                                alt="Believemy"
                                width={64}
                                height={64}
                            />
                        </div>
                    </div>

                    {/* Title */}
                    <CardTitle className="pt-4 leading-relaxed">
                        {t("CourseCard_soon_title")}
                    </CardTitle>
                </CardHeader>
                <CardContent>
                    {/* Summary */}
                    <div className="text-gray-500 dark:text-lightBlue text-sm leading-relaxed">
                        {t("CourseCard_soon_summary")}
                    </div>
                </CardContent>
            </Card>
        );
    }

    if (skeleton) {
        return (
            <div className="bg-gray-50 dark:bg-bgDark-840 rounded-card p-5 overflow-hidden border dark:border-borderDark h-full">
                <div className="flex gap-5 items-center">
                    {/* Image */}
                    <div className="relative leading-[0]">
                        <Skeleton
                            width={50}
                            height={50}
                            containerClassName="rounded-[17.544%] overflow-hidden inline-block leading-[0]"
                        />
                    </div>

                    {/* Details */}
                    <div className="flex-1 flex flex-col">
                        {/* Title */}
                        <div className="bold text-gray-200 dark:text-grayDark-800 w-1/2">
                            <Skeleton />
                        </div>
                    </div>
                </div>

                {/* Summary */}
                <div className="text-gray-200 dark:text-grayDark-800 mt-5">
                    <Skeleton count={2.4} />
                </div>
            </div>
        );
    }

    return (
        <Link href={`/course/${course.slug}`}>
            <Card className="hover:bg-gray-50 dark:bg-bgDark-840 dark:hover:border-primary dark:hover:bg-bgDark-840/70 dark:border-borderDark transition-all duration-100 h-full flex flex-col overflow-hidden">
                <CardHeader className="pb-3 flex-1">
                    <div className="flex justify-between items-start">
                        <Image
                            src={course.image}
                            alt={course.name}
                            width={64}
                            height={64}
                        />
                        <div className="flex gap-2 flex-wrap">
                            {/* {course.isPopular && (
                                <Badge>{t("course_popular")}</Badge>
                            )}
                            {course.isSoon && <Badge>{t("course_soon")}</Badge>}
                            {course.isNew && (
                                <Badge variant="confidence">
                                    {t("course_new")}
                                </Badge>
                            )}
                            {course.lang !== locale && (
                                <Badge variant="outline">
                                    {t("course_not_same_lang_short")}
                                </Badge>
                            )} */}
                        </div>
                    </div>
                    <CardTitle className="pt-4 leading-relaxed">
                        <h2>{course.name}</h2>
                    </CardTitle>
                    <CardDescription className="line-clamp-4">
                        {course.summary}
                    </CardDescription>
                </CardHeader>
                <CardContent className="px-3">
                    <div className="flex items-center gap-1">
                        <Badge variant="secondary">{course.duration}</Badge>
                    </div>
                </CardContent>
            </Card>
        </Link>
    );
}
